import React from 'react';
import { Link } from 'react-router-dom';
import Helpers from '@Apis/helpers';

const ListScreenKeys = ({ documentData, MONEY, user }) => {
  const record = documentData;
  const Po = (
    <div>
      {Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE,
        Helpers.permissionTypes.READ, user)
        ? (record?.po_number ? (
          <Link to={`/approval?type=po&id=${record?.po_id}`} target="_blank">
            {record?.po_number}
          </Link>
        ) : '-') : (record?.po_id || '')}
    </div>
  );
  const grn = (
    <div>
      {Helpers.getPermission(Helpers.permissionEntities.DEBIT_NOTE,
        Helpers.permissionTypes.READ, user)
        ? (record?.grn_number ? (
          <Link to={`/purchase/goods-receiving/view/${record?.grn_id}`} target="_blank">
            {record?.grn_number}
          </Link>
        ) : '-') : ''}
    </div>
  );

  return [
    {
      label: 'PO #',
      value: Po || '-',
    },
    {
      label: 'GRN #',
      value: grn || '-',
    },
    {
      label: 'Amount (Without Tax)',
      value: MONEY((record?.dn_base_price || '0'), record?.org_currency_info?.currency_code),
    },
    {
      label: 'Taxes',
      value: MONEY((record?.dn_taxes || '0'), record?.org_currency_info?.currency_code),
    },
  ];
};

export {
  ListScreenKeys,
};
